export const getAuthHeaders = async () => {
  try {
    if (window.Clerk && window.Clerk.session) {
      const token = await window.Clerk.session.getToken();
      return {
        Authorization: `Bearer ${token}`
      };
    }
  } catch (error) {
    console.error('Error getting auth token:', error);
  }
  return {};
};
